module.exports = __webpack_public_path__ + "img/header-diamondJewelryBestseller@2x.921470b.webp";